import { IonPage, IonContent } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { Home, Plus } from "lucide-react";
import { useStore } from "../../store/useStore";
import { PageHeader } from "../../components/ui/PageHeader";
import { Button } from "../../components/ui/Button";
import { ListRow } from "../../components/ui/ListRow";
import { RoomIcon } from "../../components/ui/RoomIcon";
import { EmptyState } from "../../components/EmptyState";
import { pluralizeTasks } from "../../logic/home-stats";

export default function ManageAreasPage() {
  const history = useHistory();
  const areas = useStore((s) => s.areas);
  const tasks = useStore((s) => s.tasks);

  return (
    <IonPage>
      <PageHeader
        title="Manage Areas"
        backHref="/settings"
        actions={
          <Button
            size="sm"
            variant="soft"
            leadingIcon={<Plus className="w-4 h-4" aria-hidden="true" />}
            onClick={() => history.push("/areas/create")}
            className="min-h-[44px]"
          >
            Add Area
          </Button>
        }
      />
      <IonContent>
        <div className="max-w-lg mx-auto px-4 py-4 pb-28">
          {areas.length > 0 ? (
            <div className="card-surface overflow-hidden divide-y divide-border">
              {areas.map((area) => {
                const areaTaskCount = tasks.filter(
                  (t) => t.area_uuid === area.uuid
                ).length;
                return (
                  <ListRow
                    key={area.uuid}
                    title={area.name}
                    subtitle={pluralizeTasks(areaTaskCount)}
                    leading={<RoomIcon name={area.name} size="sm" />}
                    onClick={() => history.push(`/areas/${area.uuid}?mode=edit`)}
                  />
                );
              })}
            </div>
          ) : (
            <EmptyState
              icon={Home}
              title="No areas yet"
              description="Add areas to organize your tasks."
              action={{
                label: "Add First Area",
                onClick: () => history.push("/areas/create"),
              }}
            />
          )}
        </div>
      </IonContent>
    </IonPage>
  );
}
